import { render, staticRenderFns } from "./StoriesArchiveSort.vue?vue&type=template&id=6c88ca02&scoped=true&"
import script from "./StoriesArchiveSort.vue?vue&type=script&lang=ts&"
export * from "./StoriesArchiveSort.vue?vue&type=script&lang=ts&"
import style0 from "./StoriesArchiveSort.vue?vue&type=style&index=0&id=6c88ca02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c88ca02",
  null
  
)

export default component.exports